import ReactGA from 'react-ga4';

const getMeasurementId = () => {
  const envId = 'G-XQ0E04FNKS';
  if (envId) {
    return envId;
  }
  if (typeof document === 'undefined') {
    return '';
  }
  const script = document.querySelector('script[src*="googletagmanager.com/gtag/js?id="]') as HTMLScriptElement | null;
  const src = script?.getAttribute('src');
  const match = src?.match(/id=([^&]+)/);
  return match?.[1] || '';
};

let initialized = false;

const ensureInitialized = () => {
  if (initialized || ReactGA.isInitialized) {
    return true;
  }
  const measurementId = getMeasurementId();
  if (!measurementId) {
    return false;
  }
  ReactGA.initialize(measurementId);
  initialized = true;
  return true;
};

export const initializeAnalytics = () => {
  ensureInitialized();
};

export const trackPageView = (path: string) => {
  if (!ensureInitialized()) {
    return;
  }
  ReactGA.send({ hitType: 'pageview', page: path, title: document.title });
};

export const trackEvent = (name: string, params?: Record<string, unknown>) => {
  if (!ensureInitialized()) {
    return;
  }
  ReactGA.event(name, params);
};

export const setUserId = (userId?: string) => {
  if (!userId || !ensureInitialized()) {
    return;
  }
  ReactGA.set({ userId });
};

export const setUserProperties = (properties: Record<string, unknown>) => {
  if (!ensureInitialized()) {
    return;
  }
  ReactGA.gtag('set', 'user_properties', properties);
};
